
  import {computed, defineComponent, ref} from 'vue';
  import Sidebar from './components/Sidebar/index.vue'
  import UHeader from './components/UHeader/index.vue'
  import AppMain from './components/AppMain.vue'
  import {useResizeHandler} from './hooks/useResizeHandler'

  import {useStore} from "vuex";

  export default defineComponent({
    name: 'layout',
    components: {
      Sidebar,
      UHeader,
      AppMain,
    },
    setup(){
      const store = useStore()
      // 是否折叠
      const isCollapse = computed(()=>{
        return !store.state.app.isCollapse
      })
      let {device} = useResizeHandler()

      const classObj = computed(()=>{
        return {
          hideSidebar:!store.state.app.isCollapse,
          openSidebar: store.state.app.isCollapse,
          withoutAnimation: store.state.app.withoutAnimation,
          mobile: device.value === 'mobile'
        }
      })
      const handleClickOutside = ()=> {
        store.dispatch('app/closeSideBar', { withoutAnimation: false })
      }

      return{
        isCollapse,
        device,
        classObj,
        handleClickOutside
      }
    }
  });
